import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  fetchCatalogProductsList,
  applyProductDrag,
  clearProductDrag,
  clearDeleteProductLink,
  clearPatchProductLink,
} from 'redux/catalog/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';

import CatalogProductItem
  from 'components/dashboard/catalog-content/CatalogProductItem';
import CatalogProductItemMobile
  from 'components/dashboard/catalog-content/CatalogProductItemMobile';
import CommonMessage from 'components/common/CommonMessage';

import './CatalogProductsList.css';

class CatalogProductsList extends Component {
  static propTypes = {
    fetchCatalogProductsList: PropTypes.func.isRequired,
    applyProductDrag: PropTypes.func.isRequired,
    clearProductDrag: PropTypes.func.isRequired,
    clearDeleteProductLink: PropTypes.func.isRequired,
    clearPatchProductLink: PropTypes.func.isRequired,
    catalogProductsList: PropTypes.arrayOf(PropTypes.shape),
    catalogProductsListError: PropTypes.object,
    productsDragSuccess: PropTypes.object,
    deleteProductLinkSuccess: PropTypes.object,
    patchProductLinkSuccess: PropTypes.object,
    device: PropTypes.string.isRequired,
  };

  static defaultProps = {
    catalogProductsList: null,
    catalogProductsListError: null,
    productsDragSuccess: null,
    deleteProductLinkSuccess: null,
    patchProductLinkSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.catalogProductsList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.catalogProductsList !== this.props.catalogProductsList) {
      this.setState({ items: this.props.catalogProductsList });
    }

    // Drag and Drop
    if (
      !prevProps.productsDragSuccess &&
      prevProps.productsDragSuccess !== this.props.productsDragSuccess
    ) {
      this.props.fetchCatalogProductsList();
      this.props.clearProductDrag();
    }

    // Delete
    if (
      !prevProps.deleteProductLinkSuccess &&
      prevProps.deleteProductLinkSuccess !== this.props.deleteProductLinkSuccess
    ) {
      this.props.fetchCatalogProductsList();
      this.props.clearDeleteProductLink();
    }

    // Patch
    if (
      !prevProps.patchProductLinkSuccess &&
      prevProps.patchProductLinkSuccess !== this.props.patchProductLinkSuccess
    ) {
      this.props.fetchCatalogProductsList();
      setTimeout(() => {
        this.props.clearPatchProductLink();
      }, 500);
    }
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyProductDrag(form);
    });
  };

  renderProductsList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {this.props.device === 'desktop' ?
                        <CatalogProductItem
                          key={`catalog-product-item-key-${item.id}`}
                          item={item}
                          patchProductLinkSuccess={this.props.patchProductLinkSuccess}
                        />
                        :
                        <CatalogProductItemMobile
                          key={`catalog-product-item-mobile-key-${item.id}`}
                          item={item}
                          patchProductLinkSuccess={this.props.patchProductLinkSuccess}
                        />
                      }
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { catalogProductsList, catalogProductsListError } = this.props;
    const { items } = this.state;

    return (
      <div className="catalog-products-list__component">
        {/* Loader */}
        {!catalogProductsList && !catalogProductsListError &&
          <Loader active />
        }

        {/* Product List */}
        {items && items.length > 0 &&
          this.renderProductsList()
        }

        {/* Fetch Products Error */}
        {catalogProductsListError &&
          <CommonMessage
            error
            errors={catalogProductsListError}
          />
        }

      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    catalogProductsList: state.catalogReducer.catalogProductsList,
    catalogProductsListError: state.catalogReducer.catalogProductsListError,
    productsDragSuccess: state.catalogReducer.productsDragSuccess,
    deleteProductLinkSuccess: state.catalogReducer.deleteProductLinkSuccess,
    patchProductLinkSuccess: state.catalogReducer.patchProductLinkSuccess,
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCatalogProductsList,
    applyProductDrag,
    clearProductDrag,
    clearDeleteProductLink,
    clearPatchProductLink,
  },
)(CatalogProductsList);
